// Add your custom JS here.
jQuery(function ($) {
    let isScrolled = false;

    $(window).on("scroll", function () {
        const scroll = $(window).scrollTop();
        const header = $("header.header-site");

        if (!isScrolled && scroll > 60) {
            isScrolled = true;
            header.addClass("scrolled");
        } else if (isScrolled && scroll < 20) {
            isScrolled = false;
            header.removeClass("scrolled");
        }
    });
});

jQuery(document).ready(function ($) {
    $('[tabindex="0"]').keydown(function (event) {
        if (event.key === "Enter" || event.key === " ") {
            $(this).click();
        }
    });
});

// Footer visibility detection for header styling
document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("#wrapper-navbar");
    const footer = document.querySelector("#wrapper-footer");

    if (!header || !footer) return;

    let observer = null;

    function setupFooterObserver() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }

        document.body.classList.remove("footer-visible");

        const isDesktop = window.innerWidth >= 768;
        const pageIsScrollable =
            document.documentElement.scrollHeight > window.innerHeight;

        if (!isDesktop || !pageIsScrollable) return;

        observer = new IntersectionObserver(
            ([entry]) => {
                const footerBottomReached =
                    entry.boundingClientRect.bottom <= window.innerHeight;

                document.body.classList.toggle(
                    "footer-visible",
                    entry.isIntersecting && footerBottomReached,
                );
            },
            {
                threshold: 1,
            },
        );

        observer.observe(footer);
    }

    setupFooterObserver();

    let resizeTimeout;
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(setupFooterObserver, 150);
    });
});

/*skip content*/
document.addEventListener("DOMContentLoaded", function () {
    const LinkGoSecondSection = document.getElementById("GoSecondSection");
    LinkGoSecondSection.addEventListener("click", function (event) {
        event.preventDefault();
        const secondSection = document.querySelector(
            ".general-section:nth-of-type(2)",
        );
        if (secondSection) {
            secondSection.scrollIntoView({ behavior: "smooth" });
        } else {
            console.error("the second section was not found.");
        }
    });
});

function autosize() {
    var el = this;
    setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        // for box-sizing other than "content-box" use:
        // el.style.cssText = '-moz-box-sizing:content-box';
        el.style.cssText = "height:" + (el.scrollHeight + 2) + "px";
    }, 0);
}

document.fonts.ready.then(function () {
    document.body.classList.add("font-loaded");
});

// AOS (Animate On Scroll) refresh on AJAX content load
document.addEventListener("DOMContentLoaded", function () {
    if (typeof AOS === "undefined") return;
    jQuery(document).on("sf:ajaxfinish", function () {
        AOS.refreshHard();
    });

    var target = document.querySelector("#block-search-and-filter");
    if (target) {
        var resizeObserver = new ResizeObserver(function () {
            AOS.refreshHard();
        });
        resizeObserver.observe(target);
    }
});

// Header Buttons in Mega Menu Mobile
document.addEventListener("DOMContentLoaded", function () {
    const headerButtons = document.querySelector(".header-buttons");
    const megaMenu = document.querySelector("#mega-menu-primary");

    const liButtons = document.createElement("li");
    liButtons.className =
        "mega-menu-item mega-menu-item-type-custom mega-align-bottom-left mega-menu-flyout menu-item-header-buttons";

    let isInMegaMenu = false;

    function moveButtonsToMenu() {
        if (window.innerWidth <= 1000 && !isInMegaMenu) {
            if (headerButtons && megaMenu) {
                liButtons.appendChild(headerButtons);
                megaMenu.appendChild(liButtons);
                isInMegaMenu = true;
            }
        } else if (window.innerWidth > 1000 && isInMegaMenu) {
            const originalContainer =
                document.querySelector(".content-elements");
            if (originalContainer && headerButtons) {
                originalContainer.appendChild(headerButtons);
                if (liButtons.parentNode)
                    liButtons.parentNode.removeChild(liButtons);
                isInMegaMenu = false;
            }
        }
    }

    moveButtonsToMenu();
    window.addEventListener("resize", moveButtonsToMenu);
});

// Lenis + smooth hash links + sticky anchorlinks (single scroll system)
document.addEventListener("DOMContentLoaded", function () {
    let lenis = null;
    if (typeof Lenis !== "undefined") {
        try {
            lenis = new Lenis({ autoRaf: true });
        } catch (e) {}
    }

    const isMobile = window.innerWidth < 992;
    const genericHashOffset = isMobile ? 180 : 230;

    function scrollDocumentToY(y, behavior) {
        const smooth = behavior === "smooth";
        if (lenis) {
            lenis.scrollTo(y, { duration: smooth ? 1.2 : 0 });
        } else {
            window.scrollTo({ top: y, behavior: smooth ? "smooth" : "auto" });
        }
    }

    function normalizePath(p) {
        return p.replace(/\/$/, "") || "/";
    }

    function isSamePageUrl(url) {
        try {
            return (
                url.origin === window.location.origin &&
                normalizePath(url.pathname) ===
                    normalizePath(window.location.pathname)
            );
        } catch (e) {
            return false;
        }
    }

    function getHashForCurrentPageLink(linkEl) {
        const href = (linkEl.getAttribute("href") || "").trim();
        if (href.startsWith("#")) return href;
        try {
            const url = new URL(linkEl.href);
            if (!isSamePageUrl(url)) return "";
            return url.hash || "";
        } catch (e) {
            return "";
        }
    }

    const anchorLinks = document.querySelectorAll(".anchorlinks a");
    const sections = [];
    let scrollingByClick = false;

    function getDynamicOffset() {
        const wpAdminBar = document.querySelector("#wpadminbar");
        const header =
            document.querySelector("#wrapper-navbar") ||
            document.querySelector("header.header-site") ||
            document.querySelector("header");

        const adminBarHeight = wpAdminBar ? wpAdminBar.offsetHeight : 0;
        const headerHeight = header ? header.offsetHeight : 0;

        return adminBarHeight + headerHeight;
    }

    function getStickyBar() {
        return document.querySelector(".sticky-anchorlinks");
    }

    function getStickyBarHeight() {
        const bar = getStickyBar();
        return bar ? bar.offsetHeight : 0;
    }

    function computeScrollMarginForSection() {
        const extraBreathingPx = 200;
        return getDynamicOffset() + getStickyBarHeight() + extraBreathingPx;
    }

    function scrollWindowToYForAnchor(y) {
        window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
    }

    function scrollAnchorIntoPlace(scrollTarget, margin) {
        if (!scrollTarget) return;
        scrollTarget.style.scrollMarginTop = margin + "px";
        if (lenis && typeof lenis.scrollTo === "function") {
            try {
                lenis.scrollTo(scrollTarget, {
                    offset: -margin,
                    duration: 1.2,
                });
            } catch (e) {
                const y =
                    scrollTarget.getBoundingClientRect().top +
                    window.scrollY -
                    margin;
                scrollWindowToYForAnchor(y);
            }
        } else {
            const y =
                scrollTarget.getBoundingClientRect().top +
                window.scrollY -
                margin;
            scrollWindowToYForAnchor(y);
        }
    }

    function getAnchorScrollTarget(el) {
        return el || null;
    }

    function applyScrollMarginsToSections() {
        const marginPx = computeScrollMarginForSection();
        sections.forEach(({ section }) => {
            if (section) {
                section.style.scrollMarginTop = marginPx + "px";
            }
        });
    }

    anchorLinks.forEach((link) => {
        const hash = getHashForCurrentPageLink(link);
        if (!hash) return;
        const section = document.querySelector(hash);
        if (section) {
            sections.push({
                link: link,
                section: section,
                id: hash,
            });
        }
    });

    applyScrollMarginsToSections();

    function scrollToGenericHash(hash) {
        const el = document.querySelector(hash);
        if (!el) return;
        const y =
            el.getBoundingClientRect().top +
            window.pageYOffset -
            genericHashOffset;
        setTimeout(() => {
            scrollDocumentToY(Math.max(0, y), "smooth");
        }, 50);
    }

    function scrollToAnchorTarget(hash) {
        const el = document.querySelector(hash);
        if (!el) return;
        const margin = computeScrollMarginForSection();
        setTimeout(() => scrollAnchorIntoPlace(el, margin), 50);
    }

    if (window.location.hash) {
        const el = document.querySelector(window.location.hash);
        const isAnchorTarget = el && sections.some((s) => s.section === el);
        if (isAnchorTarget) {
            scrollToAnchorTarget(window.location.hash);
        } else {
            scrollToGenericHash(window.location.hash);
        }
    }

    document
        .querySelectorAll('a[href^="#"]:not(.anchorlinks a)')
        .forEach((link) => {
            link.addEventListener("click", function (e) {
                const hash = this.getAttribute("href");
                if (hash.length > 1) {
                    e.preventDefault();
                    history.pushState(null, "", hash);
                    scrollToGenericHash(hash);
                }
            });
        });

    function updateActiveFromScroll() {
        if (scrollingByClick || !sections.length) return;

        const line =
            window.scrollY + getDynamicOffset() + getStickyBarHeight() + 80;
        const forwardTolerance = 140;
        let bestIdx = -1;
        let bestDistance = Number.POSITIVE_INFINITY;

        for (let i = 0; i < sections.length; i++) {
            const top =
                sections[i].section.getBoundingClientRect().top +
                window.scrollY;
            if (top <= line + forwardTolerance) {
                const distance = Math.abs(top - line);
                if (distance < bestDistance) {
                    bestDistance = distance;
                    bestIdx = i;
                }
            }
        }

        if (bestIdx === -1) {
            bestIdx = 0;
        }

        anchorLinks.forEach((l) => l.classList.remove("active"));
        if (bestIdx >= 0) {
            sections[bestIdx].link.classList.add("active");
        }
    }

    function bindScrollSpy() {
        const onScroll = () => updateActiveFromScroll();
        if (lenis) {
            lenis.on("scroll", onScroll);
        } else {
            window.addEventListener("scroll", onScroll, { passive: true });
        }
        updateActiveFromScroll();
    }

    if (!anchorLinks.length) return;

    bindScrollSpy();

    anchorLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
            const hash = getHashForCurrentPageLink(this);
            if (!hash) return;
            const targetSection = document.querySelector(hash);
            if (!targetSection) return;

            e.preventDefault();
            history.pushState(null, "", hash);

            const margin = computeScrollMarginForSection();

            scrollingByClick = true;
            scrollAnchorIntoPlace(targetSection, margin);

            anchorLinks.forEach((l) => l.classList.remove("active"));
            this.classList.add("active");

            setTimeout(() => {
                scrollingByClick = false;
                updateActiveFromScroll();
            }, 1500);
        });
    });

    const stickyBar = getStickyBar();
    if (stickyBar) {
        const placeholder = document.createElement("div");
        placeholder.classList.add("sticky-placeholder");
        placeholder.style.height = stickyBar.offsetHeight + "px";
        placeholder.style.display = "none";
        placeholder.style.width = "100%";
        stickyBar.parentNode.insertBefore(placeholder, stickyBar);

        let stickyOriginalPos =
            stickyBar.getBoundingClientRect().top + window.scrollY;

        const recalcStickyGeometry = () => {
            stickyBar.classList.remove("is-fixed");
            stickyBar.style.top = "";
            placeholder.style.display = "none";

            const style = window.getComputedStyle(stickyBar);

            stickyOriginalPos =
                stickyBar.getBoundingClientRect().top + window.scrollY;

            placeholder.style.height = stickyBar.offsetHeight + "px";
            placeholder.style.marginTop = style.marginTop;
            placeholder.style.marginBottom = style.marginBottom;

            applyScrollMarginsToSections();
        };

        let isScrolling = false;
        const handleScroll = () => {
            if (!isScrolling) {
                window.requestAnimationFrame(() => {
                    if (window.innerWidth <= 765) {
                        stickyBar.classList.remove("is-fixed");
                        stickyBar.style.top = "";
                        placeholder.style.display = "none";
                    } else {
                        const scrollY = window.scrollY;
                        let dynamicTop = getDynamicOffset();

                        if (
                            document.body.classList.contains("footer-visible")
                        ) {
                            dynamicTop = 0;
                        }

                        // Disable sticky once we've passed the last anchor target section.
                        let passedLastAnchor = false;
                        if (sections.length) {
                            const lastSection =
                                sections[sections.length - 1].section;
                            const lastSectionBottom =
                                lastSection.getBoundingClientRect().bottom +
                                window.scrollY;
                            const stickyBottomLine =
                                scrollY + dynamicTop + stickyBar.offsetHeight;
                            passedLastAnchor =
                                stickyBottomLine >= lastSectionBottom;
                        }

                        if (
                            scrollY >= stickyOriginalPos - getDynamicOffset() &&
                            !passedLastAnchor
                        ) {
                            stickyBar.classList.add("is-fixed");
                            stickyBar.style.top = dynamicTop + "px";
                            placeholder.style.display = "block";
                        } else {
                            stickyBar.classList.remove("is-fixed");
                            stickyBar.style.top = "";
                            placeholder.style.display = "none";
                        }
                    }
                    isScrolling = false;
                });
                isScrolling = true;
            }
        };

        let resizeTimeout;
        const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                recalcStickyGeometry();
                handleScroll();
            }, 100);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleResize, { passive: true });
        window.addEventListener("load", () => {
            recalcStickyGeometry();
            handleScroll();
        });

        if (typeof ResizeObserver !== "undefined") {
            const ro = new ResizeObserver(() => {
                handleResize();
            });
            if (stickyBar.parentNode) {
                ro.observe(stickyBar.parentNode);
            }
        }

        handleScroll();
    }
});

// Custom Parallax Effect for .image-parallax

document.addEventListener("DOMContentLoaded", function () {
    const parallaxImages = document.querySelectorAll(".image-parallax");
    if (parallaxImages.length === 0) return;

    function applyParallax() {
        parallaxImages.forEach(function (img) {
            const wrapper = img.parentElement;
            const rect = wrapper.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if (rect.top <= windowHeight && rect.bottom >= 0) {
                const totalDistance = windowHeight + rect.height;
                const scrolledDistance = windowHeight - rect.top;
                const percentage = scrolledDistance / totalDistance;

                const isMobile = window.innerWidth <= 768;
                const multiplier = isMobile ? 80 : 40;

                const movementY = (percentage - 0.5) * multiplier;

                const scaleAmount = isMobile ? 1.25 : 1;

                img.style.transform = `translateY(${movementY}%) scale(${scaleAmount})`;
            }
        });
    }

    window.addEventListener("scroll", function () {
        requestAnimationFrame(applyParallax);
    });
    window.addEventListener("resize", function () {
        requestAnimationFrame(applyParallax);
    });
    applyParallax();
});

// Job Openings Accordion
document.addEventListener("DOMContentLoaded", function () {
    const containers = document.querySelectorAll(".job-openings");

    containers.forEach(function (container) {
        const accordions = container.querySelectorAll(".js-accordion-trigger");
        accordions.forEach(function (btn) {
            btn.addEventListener("click", function () {
                const item = this.closest(".job-openings__accordion-item");
                const content = item.querySelector(
                    ".job-openings__accordion-content",
                );

                if (
                    item.classList.contains(
                        "job-openings__accordion-item--is-open",
                    )
                ) {
                    item.classList.remove(
                        "job-openings__accordion-item--is-open",
                    );
                    content.style.display = "none";
                } else {
                    const openItems = container.querySelectorAll(
                        ".job-openings__accordion-item--is-open",
                    );
                    openItems.forEach(function (openItem) {
                        openItem.classList.remove(
                            "job-openings__accordion-item--is-open",
                        );
                        const openContent = openItem.querySelector(
                            ".job-openings__accordion-content",
                        );
                        if (openContent) {
                            openContent.style.display = "none";
                        }
                    });

                    item.classList.add("job-openings__accordion-item--is-open");
                    content.style.display = "block";
                }
                setTimeout(function () {
                    if (typeof AOS !== "undefined") {
                        AOS.refresh();
                    }
                }, 100);
            });
        });
    });
});
